export const getInitialsFromName = (name) => {
    if (!name) {
        return null;
    }
    return name
        .split(' ')
        .slice(0, 2)
        .map((namePart) => namePart.charAt(0).toUpperCase());
};
